export default class ErrorBalloon {
  constructor() {

    this.CL_SHOW = 'isShow';

    this.isOpen = false;

    const html = `<span class="-txt"><span></span></span>`;

    this.target = document.createElement('div');
    this.target.classList.add('css_search_error_balloon');
    this.target.innerHTML = html;

    document.body.appendChild(this.target);

    this.timerId = null;
    this.isLeft = true;
  }

  onDelete(){
    clearTimeout(this.timerId);
    this.target.remove();
  }

  setArrowDirection(flag = true){
    this.target.dataset.left = flag;
    this.isLeft = flag;
  }

  show(_targetEl,_msg){
    this.isOpen = true;
    clearTimeout(this.timerId);

    this.target.querySelector('.-txt span').innerText = _msg;

    const rect = _targetEl.getBoundingClientRect();
    let left = rect.left + window.scrollX;
    if(!this.isLeft){
      const r = this.target.getBoundingClientRect();
      left = left - r.width + rect.width;
    }
    this.target.style.left = left + 'px';

    const top = rect.top + rect.height + window.scrollY;
    this.target.style.top = top + 12 + 'px';


    this.target.classList.add(this.CL_SHOW);

    this.timerId = setTimeout(()=>{
      this.hide();
    },3000);
  }

  hide(){
    this.isOpen = false;
    clearTimeout(this.timerId);
    this.target.classList.remove(this.CL_SHOW);
  }
}
